<div class="flex gap-4 items-center">
  <button mat-icon-button (click)="goBack()" class="!bg-red">
    <mat-icon class="action-icons">chevron_left</mat-icon>
  </button>

  <div class="title-description">
    <h1>{{ title }}</h1>
    <span>{{ description }}</span>
  </div>
</div>
